<template>
  <p
    :class="['notFound__title', {'notFound__title_paddingless': this.paddingSmall}]"
  >
    {{ this.loading ? 'Загрузка...' : this.text || 'Ничего не найдено' }}
  </p>
</template>

<script>
export default {
  name: "NotFoundText",
  props: ['text', 'paddingSmall', 'loading']
}
</script>

<style scoped lang="scss">
.notFound__title {
  width: 100%;
  text-align: center;
  margin: 0;
  padding: 15px 0;
  color: #8c929b;
  font-size: 14px;
  &_paddingless {
    padding: 5px 0;
  }
}
</style>
